import React from 'react'
import DangerImg from  './images/danger.svg'
import InfoImg from  './images/info.svg'
import WarningImg from  './images/warning.svg'
import { HintStyle } from './Hint.css'


const getType = props => {

  switch (props['type']) {
    case 'danger' : return {
      symbol: '❗',
      className: 'hint-danger',
      image: 'DangerImg'
    }

    case "warning": return {
      symbol: '⚠️',
      className: 'hint-warning'
    }

    case "info":
    default: return {
      symbol: 'ℹ️',
      className: 'hint-info'
    }
  }
}

const Hint = props => {
  if (props['type'] == 'danger') {
    return (
      <div css={HintStyle} className={getType(props).className}>
        <div className='icon'>
          <img src={DangerImg} />
        </div>
        <div className="content">{props.children}</div>
      </div>
    )
  } else if (props['type'] == 'warning') {
    return (
      <div css={HintStyle} className={getType(props).className}>
        <div className='icon'>
          <img src={WarningImg} />
        </div>
        <div className="content">{props.children}</div>
      </div>
    )
  } else {
    return (
      <div css={HintStyle} className='hint-info'>
        <div className='icon'>
          <img src={InfoImg} />
        </div>
        <div className="content">{props.children}</div>
    </div>
    )
  }
}

export default Hint



// import React from 'react'

// const Emoji = props => (
//   <span
//     className='emoji'
//     role='img'
//     aria-label={props.label ? props.label : ''}
//     aria-hidden={props.label ? 'false' : 'true'}
//     style={{ margin: 'auto 2em auto 0' }}
//   >
//     {props.symbol}
//   </span>
// )

// const getType = props =>
//   props['danger']
//     ? {
//       symbol: '❗️',
//       className: 'hint-danger'
//     }
//     : {
//       symbol: '⚠️',
//       className: 'hint-warning'
//     }

// const Hint = props => (
//   <div className={getType(props).className}>
//     <Emoji symbol={getType(props).symbol} />
//       <div className="content">{props.children}</div>
//   </div>
// )

// export default Hint
